var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "app-header no-print",
      class: { "transparent-nav": _vm.isTransparentNav },
      on: { mouseleave: _vm.hideExtendedMenu },
    },
    [
      _c("modal-login", {
        attrs: { shown: _vm.modal === "login", recovery: _vm.isRecoveryMode },
        on: { close: _vm.hideModal },
      }),
      _vm._v(" "),
      _c("modal-register", {
        attrs: { shown: _vm.modal === "register" },
        on: { close: _vm.hideModal },
      }),
      _vm._v(" "),
      _c("modal-details", {
        attrs: { shown: _vm.modal === "details" },
        on: { close: _vm.hideModal },
      }),
      _vm._v(" "),
      _c("modal-subscriber-details", {
        attrs: { shown: _vm.modal === "subscriber-details" },
        on: { close: _vm.hideModal },
      }),
      _vm._v(" "),
      _vm.settingsModal === "notifications"
        ? _c("notifications-dashboard")
        : _vm._e(),
      _vm._v(" "),
      _c("cookie-law"),
      _vm._v(" "),
      _vm.isMobileMenuOpen
        ? _c("div", {
            staticClass: "mobile-nav-mask",
            on: { click: _vm.closeMobileMenu },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide", mode: "out-in" } },
        [
          _vm.isMobileMenuOpen
            ? _c("mobile-nav", { on: { hide: _vm.closeMobileMenu } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "header-wrap" }, [
        _c("div", { staticClass: "header-top" }, [
          _c(
            "div",
            { staticClass: "item-left" },
            [
              _c("router-link", { staticClass: "logo", attrs: { to: "/" } }, [
                _c("img", {
                  staticClass: "logo-image",
                  attrs: {
                    src: "/assets/images/header/asoko-logo-header.png",
                    title: "Asoko Insight",
                    alt: "Asoko Insight Logo",
                  },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item-right" },
            [
              _c("account-menu"),
              _vm._v(" "),
              _c("div", { staticClass: "mobile-controls" }, [
                _c(
                  "a",
                  {
                    attrs: { "aria-label": "menu" },
                    on: { click: _vm.openMobileMenu },
                  },
                  [_c("menu-icon")],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        !_vm.isMinHeader
          ? _c("div", { staticClass: "header-bottom" }, [
              _c(
                "div",
                { staticClass: "item-block" },
                [
                  _c(
                    "router-link",
                    {
                      class: { opened: _vm.extended === "solutions" },
                      attrs: {
                        to: "/about/solutions",
                        "aria-label": "Solutions and insights",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.hideExtendedMenu.apply(null, arguments)
                        },
                        mouseover: function ($event) {
                          return _vm.showExtendedMenu("solutions")
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("Solutions and insights")]),
                      _vm._v(" "),
                      _c("chevron-up"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "item-caption" }, [
                    _vm._v(
                      "Use our corporate insights and engagement tools to discover, analyse and connect with Africa's private sector"
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.extended === "solutions"
                    ? _c("solutions-menu", {
                        directives: [
                          {
                            name: "on-clickaway",
                            rawName: "v-on-clickaway",
                            value: _vm.hideExtendedMenu,
                            expression: "hideExtendedMenu",
                          },
                        ],
                        staticClass: "extended-menu solutions-menu",
                        on: { hide: _vm.hideExtendedMenu },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item-block" },
                [
                  _c(
                    "router-link",
                    {
                      class: { opened: _vm.extended === "opportunities" },
                      attrs: {
                        to: "/about/deals",
                        "aria-label": "Opportunities for African Businesses",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.hideExtendedMenu.apply(null, arguments)
                        },
                        mouseover: function ($event) {
                          return _vm.showExtendedMenu("opportunities")
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v("Opportunities for African Businesses"),
                      ]),
                      _vm._v(" "),
                      _c("chevron-up"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "item-caption" }, [
                    _vm._v(
                      "Work with our partners to access financing and better integrate your African business into global markets"
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.extended === "opportunities"
                    ? _c("opportunities-menu", {
                        directives: [
                          {
                            name: "on-clickaway",
                            rawName: "v-on-clickaway",
                            value: _vm.hideExtendedMenu,
                            expression: "hideExtendedMenu",
                          },
                        ],
                        staticClass: "extended-menu opportunities-menu",
                        on: { hide: _vm.hideExtendedMenu },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item-block" },
                [
                  _c(
                    "router-link",
                    {
                      class: { opened: _vm.extended === "invest" },
                      attrs: {
                        to: "/matching/marketplaces",
                        "aria-label": "Engage with African Businesses",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.hideExtendedMenu.apply(null, arguments)
                        },
                        mouseover: function ($event) {
                          return _vm.showExtendedMenu("invest")
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("Engage with African Businesses")]),
                      _vm._v(" "),
                      _c("chevron-up"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "item-caption" }, [
                    _vm._v(
                      "Identify leading companies via initiatives run by investment firms, multinationals and development partners"
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.extended === "invest"
                    ? _c("deals-menu", {
                        directives: [
                          {
                            name: "on-clickaway",
                            rawName: "v-on-clickaway",
                            value: _vm.hideExtendedMenu,
                            expression: "hideExtendedMenu",
                          },
                        ],
                        staticClass: "extended-menu deals-menu",
                        on: { hide: _vm.hideExtendedMenu },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item-block" },
                [
                  _c(
                    "router-link",
                    {
                      class: { opened: _vm.extended === "about" },
                      attrs: { to: "/about/team", "aria-label": "About Us" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.hideExtendedMenu.apply(null, arguments)
                        },
                        mouseover: function ($event) {
                          return _vm.showExtendedMenu("about")
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("About us")]),
                      _vm._v(" "),
                      _c("chevron-up"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "item-caption" }, [
                    _vm._v(
                      "Get to know more about our approach, meet the team or contact us"
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.extended === "about"
                    ? _c("about-menu", {
                        directives: [
                          {
                            name: "on-clickaway",
                            rawName: "v-on-clickaway",
                            value: _vm.hideExtendedMenu,
                            expression: "hideExtendedMenu",
                          },
                        ],
                        staticClass: "extended-menu about-menu",
                        on: { hide: _vm.hideExtendedMenu },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }